/* One shipment of `fulfillment-provider/timeline/:id`. */
export type TimelineShipment = {
  _id: string;
  ETD?: string;
  ETA?: string;
  origins?: { _id: string; name?: string }[];
  destination?: unknown;
  [key: string]: unknown;
};

/** The shape the shared shipments timeline draws: dates, one origin row. */
export function toTimelineShipments(shipments?: TimelineShipment[]) {
  return (shipments ?? []).map(shipment => ({
    ...shipment,
    startDate: shipment.ETD,
    endDate: shipment.ETA,
    origin_id: shipment.origins?.map(origin => origin._id).join('') ?? '',
    origin_details: [
      {
        name: shipment.origins?.map(origin => origin.name).join(', ') ?? '',
      },
    ],
    destination_details: shipment.destination,
  }));
}
